import React, { useState, useEffect, useContext } from 'react';
import Switch from '@mui/material/Switch';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Logout from '@mui/icons-material/Logout';
import Typography from '@mui/material/Typography';
import LightModeIcon from '@mui/icons-material/LightMode';
import Cookies from 'js-cookie';
import {jwtDecode} from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../../../context/AuthContext'; // Ajusta la ruta según tu estructura

const label = { inputProps: { 'aria-label': 'Cambiar a modo oscuro' } };

function AccountMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [fullName, setFullName] = useState('');
  const open = Boolean(anchorEl);

  // Obtén la función logout del contexto
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const token = Cookies.get('access_token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        if (decoded.first_name && decoded.last_name) {
          setFullName(`${decoded.first_name} ${decoded.last_name}`);
        }
      } catch (error) {
        console.error('Error al decodificar el token JWT:', error);
      }
    }
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Al cerrar sesión, limpiamos credenciales (cookie + localStorage) y navegamos
  // con react-router para evitar la recarga completa que causaba el parpadeo.
  const handleLogout = () => {
    logout(); // limpia cookie + localStorage y actualiza el estado
    navigate('/login', { replace: true });
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            display: { xs: 'none', sm: 'block' }
          }}
        >
          {fullName || 'Usuario'}
        </Typography>
        <Tooltip title="Account settings">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <Avatar sx={{ width: 32, height: 32 }} />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleClose}>
          <Avatar /> Mi Perfil
        </MenuItem>
        <Divider />
        <MenuItem>
          <ListItemIcon>
            <LightModeIcon fontSize="small" />
          </ListItemIcon>
          <Switch {...label} defaultChecked onClick={(e) => e.stopPropagation()} />
        </MenuItem>
        <MenuItem
          onClick={() => { handleLogout(); handleClose(); }}
          sx={{
            backgroundColor: 'error.light',
            color: 'white !important',
            '&:hover': {
              backgroundColor: 'error.dark',
            },
            '& .MuiListItemIcon-root': {
              color: 'white !important',
              minWidth: '36px'
            }
          }}
        >
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Cerrar Sesión
        </MenuItem>
      </Menu>
    </>
  );
}

export default AccountMenu;
